import { render } from "./Shots.vue?vue&type=template&id=07930dd8&ts=true"
import script from "./Shots.vue?vue&type=script&lang=ts"
export * from "./Shots.vue?vue&type=script&lang=ts"

import "./Shots.vue?vue&type=style&index=0&id=07930dd8&lang=scss"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__